import { request } from '@/shared/api/request'

export const getXml = (bin = '', orgName = 0, reqId = 50, isApprove) =>
    request({ url: `contract/persCard/employee/xmlApprove?bin=${bin}&orgName=${orgName}&reqId=${reqId}&isApprove=${isApprove}`, method: 'POST' })
